import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
import router from './router'
import 'animate.css'
import 'element-plus/dist/index.css'
import './style/index.scss'
import Icons from './config/icons'
import highlightDirective from "@/directives/highlight"; // 导入指令

const app = createApp(App)

app.directive("highlight", highlightDirective);

app
  .use(store)
  .use(router)
  .use(Icons)
  .mount('#app')
